<script>
	import Menu from "../Menu/Menu.svelte";
	import Icon from "../../library/Icon.svelte";

	import { changeLabelLocale, menuIsEnabled } from "@xbs/lib-todo";
	import { getContext } from "svelte";

	export let api;

	$: state = api.getReactiveState();

	$: componentId = state.id;
	$: menuState = state.menuState;
	$: activeProject = state.activeProject;
	$: menu = state.menu;

	const locale = getContext("wx-i18n").getGroup("todo");
	$: options = changeLabelLocale(
		$menuState?.options?.length ? $menuState?.options : [],
		locale
	);

	let self = null;

	function itemClick(event) {
		const action = event.detail.action?.id ?? event.detail.action;

		if (!action) {
			api.exec("close-menu");
		} else {
			api.exec("click-menu-item", {
				id: $activeProject,
				type: "toolbar",
				action,
				params: { locale },
			});
		}
	}

	function toggleButtonClick() {
		const { menuState, activeProject } = api.getState();

		if (menuState?.open && menuState.type === "toolbar") {
			api.exec("close-menu", {
				...menuState,
			});
			return;
		}
		api.exec("open-menu", { id: activeProject, type: "toolbar" });
	}

	$: showMenu = menuIsEnabled($menu, {
		store: api.getStores().state,
		type: "toolbar",
		id: $activeProject,
	});

</script>

{#if showMenu}
	<button
		bind:this={self}
		class="wx-todo_toolbar-menu-button"
		tabindex="0"
		data-toolbar-icon={true}
		data-todo-id={$componentId}>
		<Icon name="dots-v" on:click={toggleButtonClick} />
	</button>
{/if}

{#if $menuState?.type === 'toolbar'}
	<Menu {api} {options} parent={self} on:click={itemClick} />
{/if}

<style>
	.wx-todo_toolbar-menu-button {
		cursor: pointer;
		height: var(--wx-base-size);
		width: var(--wx-base-size);

		display: flex;
		align-items: center;
		justify-content: center;

		outline: none;
		border: none;
		border-radius: 50%;

		background: inherit;
	}
	.wx-todo_toolbar-menu-button:hover {
		background: var(--wx-icon-background-hover);
	}

</style>
